import React, { Suspense } from 'react';
import { Loading } from '../../components';

/**
 * HOC to wrap a component in React.Suspense with a fallback.
 * If no fallback is provided, uses the Loading component with default style.
 */
export function withSuspense(Component, FallbackComponent) {
  return function SuspendedComponent(props) {
    const fallback = FallbackComponent ? (
      <FallbackComponent />
    ) : (
      <Loading style={{ position: 'relative' }} />
    );
    return (
      <Suspense fallback={fallback}>
        <Component {...props} />
      </Suspense>
    );
  };
}
